import { CustomerStatModel } from './customer-stat-model';
import { ChannelSubscriberStatModel } from './channel-subscriber-stat-model';
import { ChannelJobseekerStatModel } from './channel-jobseeker-stat-model';

import { ChannelAnnouncementStatModel } from './channel-announcement-stat-model';
import { Serializable } from '../../../core/models/serializable';
import { EventReportModel } from './event-report-model';
export class AdminStatsAndReportsModel
  implements Serializable<AdminStatsAndReportsModel>
{
  fromObject(obj: any): AdminStatsAndReportsModel {
    Object.assign(this, obj);
    this.channelAnnouncementStats = [];
    this.channelJobseekerStats = [];
    this.channelSubscriberStats = [];
    this.customerStats = null;

    if (
      obj.channelAnnouncementStats &&
      obj.channelAnnouncementStats.length &&
      obj.channelAnnouncementStats.length > 0
    ) {
      obj.channelAnnouncementStats.forEach((w) => {
        let t = new ChannelAnnouncementStatModel();
        t = t.fromObject(w);
        this.channelAnnouncementStats.push(t);
      });
    }

    if (
      obj.channelJobseekerStats &&
      obj.channelJobseekerStats.length &&
      obj.channelJobseekerStats.length > 0
    ) {
      obj.channelJobseekerStats.forEach((w) => {
        let t = new ChannelJobseekerStatModel();
        t = t.fromObject(w);
        this.channelJobseekerStats.push(t);
      });
    }

    if (
      obj.channelSubscriberStats &&
      obj.channelSubscriberStats.length &&
      obj.channelSubscriberStats.length > 0
    ) {
      obj.channelSubscriberStats.forEach((w) => {
        let t = new ChannelSubscriberStatModel();
        t = t.fromObject(w);
        this.channelSubscriberStats.push(t);
      });
    }

    if (obj.customerStats != null) {
      let t = new CustomerStatModel();
      t = t.fromObject(obj.customerStats);
      this.customerStats = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public channelAnnouncementStats: ChannelAnnouncementStatModel[];
  public channelJobseekerStats: ChannelJobseekerStatModel[];
  public channelSubscriberStats: ChannelSubscriberStatModel[];
  public customerStats: CustomerStatModel;
  public eventsReport: EventReportModel[];
}
